import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: "Détails de l'offre",
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Définir le montant qualifiant et la remise en %',
      qualifying_criteria: {
        title: 'Montant de dépense minimum',
        description: 'Définir le montant de dépense qualifiant',
      },
      details: {
        title: 'Remise en %',
        description: 'Définir le montant de remise dont bénéficieront les clients sur leur commande',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Définir les articles qualifiants et la remise en %',
      qualifying_criteria: {
        title: 'Articles remisés',
        description: 'Sélectionnez les articles sur lesquels vous offrez une remise.',
      },
      details: {
        title: 'Remise en %',
        description: 'Définir le montant de remise dont bénéficieront les clients sur leur commande',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Définir les articles qualifiants et la remise en {{currency}}',
      qualifying_criteria: {
        title: 'Articles remisés',
        description: 'Sélectionnez les articles sur lesquels vous offrez une remise.',
      },
      details: {
        title: 'Remise en {{currency}}',
        description: 'Définir le montant de remise dont bénéficieront les clients sur leur commande',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Définir le montant qualifiant et la remise en {{currency}}',
      qualifying_criteria: {
        title: 'Montant de dépense minimum',
        description: 'Définir le montant de dépense qualifiant',
      },
      details: {
        title: 'Remise en {{currency}}',
        description: 'Définir le montant de remise dont bénéficieront les clients sur leur commande',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Définir le montant qualifiant et les articles offerts',
      qualifying_criteria: {
        title: 'Montant de dépense minimum',
        description: "Définir le montant que le client doit dépenser pour obtenir l'article offert.",
      },
      details: {
        title: 'Articles offerts :',
        description: "Sélectionnez l'article (ou les articles) offert(s) parmi lesquels le client peut en choisir un.",
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: "Choisir les conditions de l'offre",
      qualifying_criteria: {
        title: 'Articles qualifiants',
        description: "Sélectionnez les articles que le client doit commander pour obtenir l'article offert.",
      },
      details: {
        title: 'Articles offerts :',
        description: "Sélectionnez l'article (ou les articles) offert(s) parmi lesquels le client peut en choisir un.",
      },
    },
    [OFFER_KIND.BOGO]: {
      title: "Choisir les conditions de l'offre",
      qualifying_criteria: {
        title: 'Articles qualifiants',
        description: 'Sélectionnez la catégorie dans laquelle le client doit choisir pour obtenir un article offert.',
      },
      details: {
        title: 'Article offert',
        description:
          'Les clients peuvent choisir leur deuxième article parmi les articles qualifiants sélectionnés. Le client obtiendra le moins cher des deux articles gratuitement.',
      },
    },
  },
};
